<template>
    <div class="bg-white easy-footer" :style="{ 'font-family': footer.fontFamily }">
        <div
            class="min-h-full bg-white py-12 sm:py-16 lg:py-24 px-4 lg:px-6 max-w-3xl mx-auto lg:max-w-7xl"
        >
            <DocumentHeader
                :title="$t('r_legal.privacy_policy') + footer.legal.www"
                :footer="footer"
            />
            <PolicyMain
                :footer="footer"
                :sections="sections"
                @updateIframeHeight="$emit('updateIframeHeight')"
            />
        </div>
        <FooterBody :style="{ 'font-family': footer.fontFamily }" :footer="footer" />
    </div>
</template>

<script>
import { mapState } from "vuex";
import DocumentHeader from "../shared/DocumentHeader.vue";
import FooterBody from "../footers/FooterBody.vue";
import PolicyMain from "./PolicyMain.vue";
import { i18n } from "@/i18n";

export default {
    name: "PolicyBody",
    emits: ["updateIframeHeight"],
    props: {
        footer: Object,
    },
    data() {
        return {
            jsReady: false,
            lang: i18n.global.locale.value,
        };
    },
    computed: {
        ...mapState(["globalUrl"]),
        sections() {
            if (this.jsReady) {
                return this.getPolicyContent(this.lang, this.footer, this.footer.legal);
            } else {
                return [];
            }
        },
    },
    components: {
        DocumentHeader,
        FooterBody,
        PolicyMain,
    },
    async mounted() {
        const { VUE_APP_VERSION } = process.env;

        const { getPolicyContent } = await import(
            /* webpackIgnore: true */ `${this.globalUrl}/js/content/policy.js?v=${VUE_APP_VERSION}`
        );

        this.getPolicyContent = getPolicyContent;

        this.jsReady = true;

        this.$nextTick(() => {
            this.$emit("updateIframeHeight");
        });
    },
};
</script>
